<Tailwind/>

<div class="overflow-hidden">
  {#if $sessionData.playerState !== PLAYER_STATE.puzzle}
    <div class="footer-style font-brown text-md text-[#343434]">
      <div class="policy-styles">
        <a class="text-[#343434] underline" target="_blank" href="/#/terms">{$_('common.termsOfService')}</a> &nbsp; &nbsp;  <a target="_blank" class="text-[#343434] underline" href="/#/privacy">{$_('common.privacyPolicy')}</a> &nbsp; &nbsp; <a target="_blank" class="text-[#343434] underline" href="http://company.gambit.ai/">{$_('common.website')}</a>
      </div>
    </div>
  {/if}

  {#if !['/Login', '/', '/Game', '/privacy', '/delete', '/terms', '/puzzle'].includes($location) && !$location.startsWith("/sumsub") && $location.split('/')[1] !== "mobile"}
    <NavBar/>
  {/if}

  {#if !['/Login', '/', '/Game', '/privacy', '/delete', '/terms', '/puzzle'].includes($location) && $sessionData.playerState !== PLAYER_STATE.puzzle && !$location.startsWith("/sumsub") && $location.split('/')[1] !== "mobile"}
    <Sidebar/>
  {/if}

  <div transition:fade  class:hide-sumsub={sumsub}  class="sumsub-view">
    <button on:click={toggleSumsub}>
      <img src="close.svg" alt="close.svg" />
    </button>
    <div  id="sumsub-websdk-container"/>
  </div>

  <Router {routes} />
</div>


<script>
  // Import the router component
  import {_} from 'svelte-i18n'
  // Normally, this would be: `import Router from 'svelte-spa-router'`
  import Router from 'svelte-spa-router'
  import {sessionData} from './stores.js'
  import {PLAYER_STATE} from './chess-console-app/ChessConsoleAppState.js'
  import {SvelteToast, toast} from '@zerodevx/svelte-toast/dist'
  import {fly} from 'svelte/transition'
  import Sidebar from './components/Sidebar.svelte';
  import Tailwind from './Tailwind.svelte';
  import {fade} from 'svelte/transition'

  import {getAuth, RecaptchaVerifier, onAuthStateChanged} from 'firebase/auth'
  import { launchSumsub } from './sumsub.js';
  import {onMount} from 'svelte'
  import {M} from 'svelte-motion'
  import {link, replace, location} from 'svelte-spa-router'
  import NotificationSidebar from './components/NotificationSidebar.svelte';
  // Import the list of routes

  import {getUserData, isUserRegistered} from './userdata.js'
  import NavBar from './components/NavBar.svelte'
  import routes from './routes'

  import Login from "./routes/Login.svelte";
  import {auth} from './firebase'
  import Home from "./routes/Home.svelte"
  import {includeIntercom, startIntercom} from "./lib.js"

  $: sumsub = $sessionData.sumsubHidden

  function toggleSumsub(){
    $sessionData.sumsubHidden = !$sessionData.sumsubHidden
  }

  function updateAuth(){
      if (auth.currentUser) {
        if ($location !== '/puzzle') {
          replace("/Play")
        }
      } else {
        if ($location !== '/puzzle') {
          replace("/Login")
        }
      }
    }

  onMount (async () => {

    includeIntercom();
    startIntercom();

    /* updateAuth() */
    function dispatchLinkGameEvent() {
      const detail = {
        tc: _frtc,
        stake: _frstake,
        code: _frcode
      };
      const linkGameEvent = new CustomEvent('link_game', { detail });
      window.dispatchEvent(linkGameEvent);
    }

    document.addEventListener('DOMContentLoaded', function(){
      const customEventButton = document.getElementById('customEventButton')
      if(customEventButton){
        customEventButton.addEventListener('click', dispatchLinkGameEvent)
      }
    })

    if($location.startsWith("/sumsub")) {return;}
    const _auth = getAuth();

    onAuthStateChanged(_auth, (user) => {
      if (user) {
        $sessionData.user = user
        $sessionData.signin_user.email = user.email
        $sessionData.guser = getUserData()

        // Get the Firebase token
        user.getIdToken().then((token) => {
          // Make the API call to get puzzle credits

        const gapi_url = process.env.BASE_GAMBIT_URL;
        const puzzle_credits = gapi_url + "puzzle/puzzle_credits";

         // return fetch(`${process.env.GAMBIT_PUZZLE_REST}puzzle_credits`, {
          return fetch(puzzle_credits, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
        }).then(response => response.json())
          .then(data => {
            $sessionData.puzzleCredits = data.credits;
            console.log("puzzle credits", data)
          })
          .catch(error => {
            console.error('Error fetching puzzle credits:', error);
          });

      } else {
        // User is signed out
        if($location.startsWith("/sumsub")) {return;}
        if($location != '/)' && $location.split('/')[1] != "mobile" && $location != '/privacy' && $location != '/terms'&& $location != '/delete'){
          replace('/Login')
        }
      }
    });
  })
</script>


<style>
  .footer-style {
    position: fixed;
    display: flex;
    justify-content: space-between; /* This will push the children to opposite ends */
    align-items: center; /* Vertically center the children */
    bottom: 0.4rem;
    left: 0;
    right: 0;
    padding-right: 22rem;
  }
  .sumsub-view {
    position: absolute;
    top: 50%;
    display: flex;
    background: #ffffff;
    flex-direction: column;
    padding: 5rem;
    z-index: 5000;
    opacity: 1;
    opacity: 100;
    left: 50%;

    transform: translate(-50%, -50%);
    transition:  opacity 0.5s ease-in-out;
  }
  .hide-sumsub {
    display: none !important;
    pointer-events: none !important;
    opacity:0;
    transition:  opacity 0.5s ease-in-out;
  }
  .policy-styles {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end; /* Align links to the end (right) */
    gap: 0.3rem;
  }
</style>
